import Menu, { menuClasses } from '@mui/material/Menu';
import { ChevronRight } from 'lucide-react';
import { ReactNode, useRef, useState } from 'react';
import MenuItem from './MenuItem';

type NestedMenuItemProps = {
    label: string;
    children: ReactNode | ReactNode[];
};

export default function NestedMenuItem({
    label,
    children,
}: NestedMenuItemProps) {
    const [submenuOpen, setSubmenuOpen] = useState(false);
    const menuItemRef = useRef(null);

    const handleMouseEnter = () => {
        setSubmenuOpen(true);
    };

    const handleMouseLeave = () => {
        setSubmenuOpen(false);
    };

    return (
        <div
            ref={menuItemRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <MenuItem label={label} icon={<ChevronRight size={16} />} />
            <Menu
                hideBackdrop
                style={{ pointerEvents: 'none' }}
                anchorEl={menuItemRef.current}
                open={submenuOpen}
                onClose={() => setSubmenuOpen(false)}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                MenuListProps={{
                    dense: true,
                    onMouseEnter: () => setSubmenuOpen(true),
                    onMouseLeave: () => setSubmenuOpen(false),
                }}
                sx={{
                    [`& .${menuClasses.paper}`]: {
                        marginLeft: 0.5,
                    },
                }}
            >
                <div style={{ pointerEvents: 'auto' }}>{children}</div>
            </Menu>
        </div>
    );
}
